export const mapInternalStateToPayload = state => {
  const {
    category,
    description,
    department,
    interview_template,
    languages,
    modules,
    profile,
    title,
  } = state

  return {
    category,
    description,
    interview_template: modules?.interview ? interview_template : undefined,
    languages,
    department: department.id,
    members_with_access: [],
    modules: {
      gma: modules?.gma,
      interview: modules?.interview,
      personality: modules?.personality,
    },
    name: title,
    profile: {
      categories: profile?.categories,
      outputVariables: {
        productivity: profile?.outputVariables?.productivity,
        sicknessAbsence: profile?.outputVariables?.sicknessAbsence,
        turnover: profile?.outputVariables?.turnover,
      },
    },
  }
}
